function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClockSign = function SvgClockSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 42",
    style: {
      enableBackground: "new 0 0 37 42"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.4 22.1c-.2.2-.5.4-.9.4s-.6-.1-.9-.4L17.5 16c-.2-.2-.4-.5-.4-.9V7.3c0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2v7.4l5.7 5.7c.7.5.7 1.3.2 1.7M18.5 0c-8 0-14.6 6.5-14.6 14.6s6.5 14.6 14.6 14.6 14.6-6.5 14.6-14.6S26.5 0 18.5 0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#d5d8e0"
    }
  }));
};
export default SvgClockSign;